import {
    Component,
    Input,
    Output,
    Inject,
    Host,
    forwardRef,
    ViewEncapsulation,
    EventEmitter
} from '@angular/core';
import { SmRadioGroupComponent } from './sm-radio-group.component';

@Component({
    selector: 'sm-radio-item',
    template: `
<div class="form-check"
     [class.disabled]="isDisabled()"
     [class.readonly]="isReadonly()" >
	<label class="form-check-label">
		<input class="form-check-input"
	            (click)="toggleCheck($event)"
				type="radio"
				[name]="name"
				[checked]="isChecked()"
				[disabled]="isDisabled()" />
		<span *ngIf="label">{{label}}</span>
	</label>
</div>`,
    encapsulation: ViewEncapsulation.None
})
export class SmRadioItemComponent {
    @Input() value: any;
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;
    @Input() name: string = '';
    @Input() label: string = '';
    @Output() onSelect = new EventEmitter<{ event: Event }>();

    constructor(
        @Host()
        @Inject(forwardRef(() => SmRadioGroupComponent))
        private radioGroup: SmRadioGroupComponent
    ) { }

    toggleCheck(event: MouseEvent) {
        if (this.isReadonly() || this.isDisabled()) {
            return;
        }

        if (this.radioGroup.customToggleLogic) {
            this.radioGroup.customToggleLogic({
                event: event,
                valueAccessor: this.radioGroup.valueAccessor,
                value: this.value
            });

        } else {
            this.radioGroup.valueAccessor.set(this.value);
        }

        this.onSelect.emit({ event: event });
    }

    isChecked() {
        if (this.radioGroup.customIsSelectedLogic) {
            return this.radioGroup.customIsSelectedLogic({
                valueAccessor: this.radioGroup.valueAccessor,
                value: this.value
            });
        }
        return this.radioGroup.valueAccessor.has(this.value);
    }

    isDisabled() {
        return this.disabled == true || this.radioGroup.disabled;
    }

    isReadonly() {
        return this.readonly || this.radioGroup.readonly;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/components/sm-radio-item.component.ts